export default function media() {
  return [
    'mediaItem',
    'mediaItemFeed',
    'mediaItemGrid',
    'mediaItemList',
    'groupGrid',
    'groupItem',
    'groupList',
  ];
}



// WEBPACK FOOTER //
// ./src/global-view/editor/page/droplets-tab/site-types/media.js